import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'streams',
    icon: 'video-outline',
    link: '/overview',
    home: true,
  },
 {
    title: 'videos',
    icon: 'film-outline',
     link: '/vid-overview',
    home: false,
  },
  {
    title: 'restreams',
    icon: 'radio-outline',
     link: '/restreams',
    home: false,
  }, 
 /* */  {
    title: 'playlists',
    icon: 'list-outline',
     link: '/playlists',
    home: false,
  },

 {
    title: 'stats',
    icon: 'pie-chart-outline',
   
    home: false,
	 children: [

	 {
	    title: 'views',
	    icon: 'eye-outline',
	     link: '/statistics',
	    home: false,
	  },
 	 {
	    title: 'sales',
	    icon: 'credit-card-outline',
	    link: '/income',
	    home: false,
	  }
 
	],
  },

  {
    title: 'channelSettins',
    icon: 'book-outline',
     link: '/channel-edit',
    home: false,
  },

 
  {
    title: 'myProfile',
    icon: 'person-outline',
     link: '/profile',
    home: false,
  }
];




export const MENU_ADMIN_ITEMS: NbMenuItem[] = [
 /* {
    title: 'Трансляції',
    icon: 'video-outline',
    link: '/overview',
    home: true,
  },
 {
    title: 'Відео',
    icon: 'film-outline',
     link: '/vid-overview',
    home: false,
  },
  {
    title: 'Ретрансляції',
    icon: 'radio-outline',
     link: '/restreams',
    home: false,
  }, 
    {
    title: 'Плейлисти',
    icon: 'list-outline',
     link: '/playlists',
    home: false,
  },

 {
    title: 'Статистика',
    icon: 'pie-chart-outline',
   
    home: false,
	 children: [

	 {
	    title: 'Перегляд',
	    icon: 'eye-outline',
	     link: '/statistics',
	    home: false,
	  },
 	 {
	    title: 'Продаж',
	    icon: 'credit-card-outline',
	    link: '/income',
	    home: false,
	  }
 
	],
  },

  {
    title: 'Налаштування',
    icon: 'book-outline',
     link: '/channel-edit',
    home: false,
  },

 
  {
    title: 'Мій профіль',
    icon: 'person-outline',
     link: '/profile',
    home: false,
  }, */
  {
	title: 'Керування',
	icon: 'settings-2-outline',
	home: false ,
		 children: [

		{
		title: 'Дашборд',
			icon: 'book-open-outline',
		link: '/admin/dashboard',
			home: false
		 },
                {
		title: 'Фінанси',
			icon: 'credit-card-outline',
		 
			home: false,

			children:[
			  	{
				title: 'Оплати тарифів',
				//	 icon: 'credit-card-outline',
				link: '/admin/payments',
					home: false
				 }, 
			  	{
				title: 'Продажі авторів',
				//	 icon: 'person-outline',
				link: '/admin/income',
					home: false
				 }, 
  


]
		 }, 
		{
		title: 'Користувачі',
			icon: 'people-outline',
		link: '/admin/users',
			home: false
		 },
		{
		title: 'Партнери',
			icon: 'person-outline',
		link: '/admin/partners',
			home: false
		 },
		{
		title: 'Автобаланс і CDN',
			icon: 'globe-outline',
		link: '/admin/cdn',
			home: false
		 },
		{
		title: 'Drives',
			icon: 'hard-drive-outline',
		link: '/admin/drives',
			home: false
		 },
		{
		title: 'Tech',
			icon: 'settings-2-outline',
		link: '/admin/tech',
			home: false
		 },
		{
		title: 'Log',
			icon: 'info-outline',
		link: '/admin/log',
			home: false
		 }





//
		]
	

  }

 
];
